import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=9856e7ea&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=9856e7ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9856e7ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9856e7ea')) {
      api.createRecord('9856e7ea', component.options)
    } else {
      api.reload('9856e7ea', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=9856e7ea&scoped=true&", function () {
      api.rerender('9856e7ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28nSOcv14a224/JS/comp/DocBox.vue"
export default component.exports